import useExternalHeader from "../hooks/useExternalHeader";

const Header = () => {
  const headerRef = useExternalHeader();

  return (
    <header className="header" ref={headerRef}>
      <div className="wrapper">
        <div className="row first">
          <div className="logo">
            <a className="header-logo" href="https://tfig.ny2.stonesoupdev.com">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="214"
                height="80"
                viewBox="0 0 214 80"
                fill="none"
              >
                <g clipPath="url(#clip0_1069_3508)">
                  <path
                    d="M5.27059 49.2245V51.0128H24.8471V49.2245H19.3882V16.8481H20.2353C24.3765 16.8481 27.1059 20.1422 28.4235 26.8245H30.0235L29.8353 15.0598H0.188235L0 26.8245H1.6C2.91765 20.1422 5.64706 16.8481 9.88235 16.8481H10.7294V49.2245H5.36471H5.27059Z"
                    fill="white"
                  />
                  <path
                    d="M50.9181 49.2245H45.7417V33.6951H46.5887C49.1299 33.6951 50.9181 34.3539 51.9534 35.6716C52.9887 36.9892 53.5534 38.5892 53.6475 40.3775H55.4358V25.601H53.4593C53.0828 29.8363 50.7299 31.9069 46.5887 31.9069H45.7417V16.7539H51.3887C56.4711 16.7539 59.6711 19.8598 60.8946 25.9775H62.7769L62.4946 15.0598H32.377V16.8481H36.8946V49.2245H32.377V51.0128H50.824V49.2245H50.9181Z"
                    fill="white"
                  />
                  <path
                    d="M65.0352 49.2245V51.0128H74.1646H83.3881V49.2245H78.494V16.8481H83.3881V15.0598H74.1646H65.0352V16.8481H69.741V49.2245H65.0352Z"
                    fill="white"
                  />
                  <path
                    d="M102.87 38.5887H107.67V42.1652C107.67 44.0476 107.67 45.5535 107.388 46.4946C107.2 47.4358 106.729 48.1887 105.976 48.7535C105.223 49.3182 104.188 49.6005 102.588 49.6005H102.306C100.235 49.6005 98.6352 49.0358 97.5999 48.0005C96.5646 46.9652 95.9999 45.177 95.9999 42.7299C95.9999 40.2829 95.9999 36.6123 95.9999 31.624C95.9999 26.6358 96.094 23.0593 96.3764 21.3652C96.6587 19.6711 97.3176 18.4476 98.3528 17.6005C99.3881 16.8476 100.8 16.377 102.588 16.377H102.776C108.235 16.377 111.906 19.6711 113.882 26.1652H115.67V15.5299H113.882C113.035 16.4711 112.376 17.3182 111.718 17.977C108.988 15.8123 106.07 14.6829 102.776 14.6829H102.588C98.2587 14.6829 94.3999 16.4711 91.1058 19.9534C87.7176 23.4358 86.0234 27.8593 86.0234 33.0358C86.0234 38.2123 87.6234 42.5417 90.8234 46.1182C94.0234 49.6946 97.8823 51.4829 102.588 51.4829H102.776C107.67 51.4829 112.188 49.5064 116.329 45.5535V38.5887H119.153V36.8005H102.682V38.5887H102.87Z"
                    fill="white"
                  />
                  <path
                    d="M180.8 47.6237C172.8 47.6237 166.024 52.5178 163.2 59.4825H164.141C167.153 54.2119 172.8 50.6354 179.294 50.6354C185.788 50.6354 180.33 50.6354 180.8 50.6354C186.635 51.106 191.718 54.5884 194.447 59.3884H198.4C195.577 52.4237 188.706 47.5295 180.8 47.5295V47.6237Z"
                    fill="white"
                  />
                  <path
                    d="M193.224 37.6475C189.271 36.1416 184.941 35.1063 180.894 34.4475C178.824 34.071 176.659 33.8828 174.682 33.6946C174.4 33.6946 174.212 33.6946 174.024 33.6946C173.271 33.224 172.518 32.7534 171.765 32.3769C171.765 32.2828 171.671 32.1887 171.576 32.0946C161.977 14.3063 148.235 13.5534 130.259 12.424C129.318 12.424 128.471 12.3298 127.529 12.2357C126.776 10.824 125.741 9.50632 124.612 8.28279C121.976 5.6475 118.494 3.76515 113.976 3.20044V9.03573C116.706 9.60044 118.965 10.7298 120.471 12.3298C122.447 14.3063 123.576 17.0357 123.953 19.671V56.9416H0V59.5769H129.6V19.5769V19.2946C129.506 18.2593 129.318 17.1298 129.035 16.0946C129.318 16.0946 129.694 16.0946 129.976 16.0946C143.247 16.8475 154.071 17.5063 162.259 25.6946C155.388 25.6004 148.518 25.6946 141.553 25.6946C145.788 41.1298 147.953 37.4593 166.118 38.024C171.576 38.2122 176.094 38.024 180.8 38.5887C184.282 38.9651 187.859 39.7181 191.812 41.0357C204.518 45.9298 203.576 50.824 210.071 53.3651C207.153 45.1769 200.659 40.3769 193.129 37.5534L193.224 37.6475Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M210.165 74.0711V73.6946H210.353V74.0711H210.165ZM210.165 70.1181V69.6475C210.259 69.6475 210.353 69.6475 210.447 69.6475C210.635 69.6475 210.824 69.4593 210.918 69.1769C211.012 68.8946 211.106 68.5181 211.106 67.8593C211.106 67.2005 211.106 66.824 210.918 66.6358C210.824 66.3534 210.635 66.1652 210.447 66.1652C210.447 66.1652 210.259 66.1652 210.165 66.1652V65.6946C211.294 65.6946 212.141 65.9769 212.612 66.3534C213.082 66.824 213.365 67.2946 213.365 67.9534C213.365 68.6122 213.082 69.0828 212.518 69.5534C212.047 69.9299 211.2 70.2122 210.165 70.2122V70.1181ZM210.165 65.5063V65.9769C209.976 65.9769 209.788 65.9769 209.6 65.9769H209.129V69.7416H209.6C209.788 69.7416 209.976 69.7416 210.165 69.7416V70.2122C209.976 70.2122 209.788 70.2122 209.506 70.2122H209.129V73.7887H210.165V74.1652H206.024V73.7887H207.059V66.0711H206.024V65.6946H210.165V65.5063ZM192.565 74.2593V73.8828C192.941 73.8828 193.224 73.7887 193.506 73.6005C193.788 73.4122 193.882 73.0358 193.976 72.6593C193.976 72.1887 193.976 71.3416 193.976 69.9299C193.976 68.5181 193.976 67.7652 193.976 67.2946C193.976 66.9181 193.788 66.5416 193.6 66.2593C193.412 65.9769 193.035 65.8828 192.565 65.8828V65.5063C193.506 65.5063 194.447 65.8828 195.2 66.6358C195.953 67.3887 196.329 68.5181 196.329 69.9299C196.329 71.3416 195.953 72.2828 195.2 73.1299C194.447 73.8828 193.6 74.3534 192.471 74.3534L192.565 74.2593ZM200.188 65.9769V71.5299C200.188 72.3769 200.376 73.0358 200.659 73.3181C200.941 73.6005 201.412 73.7887 201.976 73.7887C202.541 73.7887 202.729 73.7887 203.106 73.6005C203.482 73.4122 203.671 73.224 203.859 72.8475C204.047 72.5652 204.141 72.0005 204.141 71.2475V66.7299C204.141 66.4475 204.141 66.2593 204.141 66.1652C204.141 66.1652 203.953 66.0711 203.576 66.0711H203.012V65.6946H205.741V66.0711H205.365C205.082 66.0711 204.894 66.0711 204.8 66.1652C204.8 66.1652 204.706 66.4475 204.706 66.7299V71.1534C204.706 71.7181 204.706 72.1887 204.518 72.6593C204.424 73.1299 204.141 73.5064 203.671 73.7887C203.2 74.1652 202.447 74.2593 201.506 74.2593C200.565 74.2593 200.471 74.2593 200 74.0711C199.529 73.9769 199.153 73.7887 198.776 73.4122C198.494 73.1299 198.306 72.8475 198.212 72.4711C198.212 72.1887 198.118 71.8122 198.118 71.3416V65.8828H196.988V65.5063H201.412V65.8828H200.282L200.188 65.9769ZM192.565 65.4122V65.7887C192.188 65.7887 191.906 65.8828 191.624 66.0711C191.435 66.2593 191.247 66.6358 191.153 67.1064C191.153 67.5769 191.153 68.424 191.153 69.7416C191.153 71.0593 191.153 71.9064 191.153 72.3769C191.153 72.7534 191.341 73.1299 191.529 73.4122C191.718 73.6946 192.094 73.7887 192.565 73.7887V74.1652C191.435 74.1652 190.494 73.6946 189.835 72.8475C189.082 72.0005 188.8 70.9652 188.8 69.6475C188.8 68.3299 189.176 67.2946 189.929 66.5416C190.682 65.6946 191.624 65.3181 192.659 65.3181L192.565 65.4122ZM183.812 69.8358V69.2711C184.188 69.2711 184.471 69.1769 184.659 68.9887C184.847 68.8005 184.941 68.3299 184.941 67.5769C184.941 66.824 184.847 66.4475 184.659 66.2593C184.471 66.0711 184.188 65.9769 183.812 65.9769V65.6005C185.129 65.6005 186.071 65.7887 186.635 66.2593C187.106 66.6358 187.388 67.1064 187.388 67.5769C187.388 68.0475 187.2 68.5181 186.729 68.8946C186.259 69.2711 185.6 69.4593 184.659 69.6475C185.318 69.8358 185.882 70.1181 186.259 70.4005C186.635 70.6828 186.824 70.9652 186.918 71.3416C186.918 71.7181 187.012 72.0946 187.012 72.5652C187.012 73.0358 187.012 73.3181 187.106 73.5063C187.106 73.6005 187.294 73.6946 187.482 73.6946C187.671 73.6946 187.953 73.6946 188.235 73.5063V73.9769C187.859 74.1652 187.388 74.2593 186.824 74.2593C186.259 74.2593 185.6 74.0711 185.224 73.7887C184.847 73.4122 184.565 72.8475 184.565 72.0005C184.565 71.1534 184.471 70.5887 184.188 70.3063C184.094 70.2122 184 70.1181 183.812 70.024V69.8358ZM183.812 65.5063V65.8828H183.624H182.682V69.2711H183.529C183.624 69.2711 183.812 69.2711 183.906 69.2711V69.8358C183.718 69.8358 183.529 69.7416 183.247 69.7416H182.776V73.6946H183.906V74.0711H179.576V73.6946H180.706V65.9769H179.576V65.6005H183.906L183.812 65.5063ZM141.929 69.8358V69.2711C142.306 69.2711 142.588 69.1769 142.776 68.9887C142.965 68.8005 143.059 68.3299 143.059 67.5769C143.059 66.824 142.965 66.4475 142.776 66.2593C142.588 66.0711 142.306 65.9769 141.929 65.9769V65.6005C143.247 65.6005 144.188 65.7887 144.753 66.2593C145.224 66.6358 145.506 67.1064 145.506 67.5769C145.506 68.0475 145.318 68.5181 144.847 68.8946C144.376 69.2711 143.718 69.4593 142.776 69.6475C143.435 69.8358 144 70.1181 144.376 70.4005C144.753 70.6828 144.941 70.9652 145.035 71.3416C145.035 71.7181 145.129 72.0946 145.129 72.5652C145.129 73.0358 145.129 73.3181 145.224 73.5063C145.224 73.6005 145.412 73.6946 145.6 73.6946C145.788 73.6946 146.071 73.6946 146.353 73.5063V73.9769C145.976 74.1652 145.506 74.2593 144.941 74.2593C144.376 74.2593 143.718 74.0711 143.341 73.7887C142.965 73.4122 142.682 72.8475 142.682 72.0005C142.682 71.1534 142.494 70.5887 142.306 70.3063C142.212 70.2122 142.118 70.1181 141.929 70.024V69.8358ZM150.024 65.9769V73.6946H151.153V74.0711H146.729V73.6946H147.859V65.9769H146.729V65.6005H151.153V65.9769H150.024ZM151.812 65.5063H158.871V68.3299H158.494C158.212 66.7299 157.553 65.9769 156.518 65.9769H156.329V73.6946H157.647V74.0711H152.941V73.6946H154.259V65.9769H154.071C153.035 65.9769 152.376 66.7299 152.094 68.3299H151.718V65.5063H151.812ZM159.435 65.5063H163.482V65.8828H162.447L164.424 69.4593L165.929 66.5416C165.929 66.5416 165.929 66.4475 166.024 66.2593C166.024 66.1652 166.024 66.0711 166.024 65.9769C166.024 65.8828 165.929 65.7887 165.647 65.7887H165.271V65.4122H167.435V65.7887C167.059 65.7887 166.871 65.7887 166.682 65.8828C166.588 65.8828 166.4 66.1652 166.212 66.4475L164.424 69.8358V73.4122H165.741V73.7887H161.035V73.4122H162.353V69.9299L159.906 65.6946H159.247V65.3181L159.435 65.5063ZM178.541 71.1534V72.8475C177.506 73.7887 176.471 74.2593 175.341 74.2593C174.212 74.2593 173.271 73.7887 172.518 72.9416C171.765 72.0946 171.388 71.0593 171.388 69.8358C171.388 68.6122 171.765 67.5769 172.612 66.7299C173.459 65.8828 174.306 65.5063 175.435 65.5063C176.565 65.5063 176.941 65.7887 177.6 66.2593C177.788 66.0711 177.882 65.8828 178.071 65.6946H178.541V68.2358H178.071C177.6 66.6358 176.753 65.8828 175.435 65.8828C174.118 65.8828 174.682 65.9769 174.4 66.1652C174.118 66.3534 174.024 66.6358 173.929 67.1064C173.929 67.4828 173.835 68.3299 173.835 69.5534C173.835 70.7769 173.835 71.624 173.835 72.1887C173.835 72.7534 173.929 73.224 174.212 73.4122C174.494 73.6946 174.871 73.7887 175.341 73.7887C175.812 73.7887 176 73.7887 176.188 73.6005C176.376 73.5063 176.471 73.3181 176.471 73.0358C176.471 72.8475 176.471 72.4711 176.471 72.0005V71.1534H175.341V70.7769H179.294V71.1534H178.635H178.541ZM141.929 65.5063V65.8828H141.741H140.8V69.2711H141.647C141.741 69.2711 141.835 69.2711 142.024 69.2711V69.8358C141.835 69.8358 141.647 69.7416 141.365 69.7416H140.894V73.6946H142.024V74.0711H137.694V73.6946H138.824V65.9769H137.694V65.6005H142.024L141.929 65.5063ZM83.0118 71.7181V71.2475H84.1412L83.0118 68.2358C83.0118 68.3299 83.0118 67.2005 83.0118 67.2005L83.7647 65.3181H84.1412L87.2471 73.6005H88.0941V73.9769H83.8588V73.6005H84.9882L84.2353 71.624H82.9176L83.0118 71.7181ZM95.8118 74.0711H88.6588V73.6946H89.7882V65.9769H88.6588V65.6005H93.1765V65.9769H91.8588V73.6946H92.7059C93.1765 73.6946 93.4588 73.6946 93.7412 73.6946C93.9294 73.6946 94.2118 73.5064 94.4941 73.3181C94.7765 73.1299 94.9647 72.8475 95.1529 72.4711C95.3412 72.0946 95.5294 71.7181 95.6235 71.3416H96V74.2593H95.9059L95.8118 74.0711ZM102.871 65.9769V73.6946H104V74.0711H99.5765V73.6946H100.706V65.9769H99.5765V65.6005H104V65.9769H102.871ZM107.671 65.5063L111.059 70.4946V66.824C111.059 66.4475 111.059 66.1652 110.965 66.0711C110.965 65.9769 110.682 65.8828 110.4 65.8828H110.024V65.5063H112.659V65.8828H112.376C112.094 65.8828 111.812 65.8828 111.812 66.0711C111.812 66.1652 111.718 66.3534 111.718 66.6358V74.1652H111.247L106.165 66.6358V72.8475C106.165 73.224 106.165 73.4122 106.259 73.5063C106.259 73.6005 106.541 73.6946 106.824 73.6946H107.294V74.0711H104.565V73.6946H104.941C105.318 73.6946 105.506 73.6946 105.6 73.5063C105.6 73.4122 105.694 73.1299 105.694 72.5652V66.6358C105.694 66.3534 105.694 66.0711 105.694 66.0711C105.694 66.0711 105.412 65.9769 105.129 65.9769H104.659V65.6005H107.859L107.671 65.5063ZM113.035 65.5063H120.094V68.3299H119.718C119.435 66.7299 118.776 65.9769 117.741 65.9769H117.553V73.6946H118.871V74.0711H114.165V73.6946H115.482V65.9769H115.294C114.259 65.9769 113.6 66.7299 113.318 68.3299H112.941V65.5063H113.035ZM124.047 65.9769V69.5534H124.329C125.176 69.5534 125.741 69.0828 125.835 68.0475H126.212V71.5299H125.835C125.835 70.4946 125.271 69.9299 124.329 69.9299H124.047V73.6005H125.553C126.871 73.6005 127.718 72.8475 128.094 71.2475H128.565L128.376 74.0711H120.941V73.6946H122.071V65.9769H120.941V65.6005H128.094V67.9534C128.188 67.9534 127.812 67.9534 127.812 67.9534C127.529 67.1063 127.247 66.6358 126.776 66.3534C126.4 66.0711 125.835 65.9769 125.176 65.9769H124.047ZM136.565 71.1534V72.8475C135.529 73.7887 134.494 74.2593 133.365 74.2593C132.235 74.2593 131.294 73.7887 130.541 72.9416C129.788 72.0946 129.412 71.0593 129.412 69.8358C129.412 68.6122 129.788 67.5769 130.635 66.7299C131.482 65.8828 132.329 65.5063 133.459 65.5063C134.588 65.5063 134.965 65.7887 135.624 66.2593C135.812 66.0711 135.906 65.8828 136.094 65.6946H136.565V68.2358H136.094C135.624 66.6358 134.776 65.8828 133.459 65.8828C132.141 65.8828 132.706 65.9769 132.424 66.1652C132.141 66.3534 132.047 66.6358 131.953 67.1064C131.953 67.4828 131.859 68.3299 131.859 69.5534C131.859 70.7769 131.859 71.624 131.859 72.1887C131.859 72.7534 131.953 73.224 132.235 73.4122C132.518 73.6946 132.894 73.7887 133.365 73.7887C133.835 73.7887 134.024 73.7887 134.212 73.6005C134.4 73.5063 134.494 73.3181 134.494 73.0358C134.494 72.8475 134.494 72.4711 134.494 72.0005V71.1534H133.365V70.7769H137.318V71.1534H136.659H136.565ZM83.0118 67.2005V68.3299L81.8824 71.1534H83.0118V71.624H81.6941L81.3176 72.4711C81.2235 72.8475 81.1294 73.0358 81.1294 73.224C81.1294 73.4122 81.3176 73.6005 81.7882 73.6005H82.2588V73.9769H79.5294V73.6005H79.8118C80.0941 73.6005 80.3765 73.6005 80.4706 73.4122C80.5647 73.3181 80.7529 73.0358 80.8471 72.6593L83.1059 67.1064L83.0118 67.2005ZM53.4588 71.7181V71.2475H54.5882L53.4588 68.2358C53.4588 68.3299 53.4588 67.2005 53.4588 67.2005L54.2118 65.3181H54.5882L57.6941 73.6005H58.5412V73.9769H54.3059V73.6005H55.4353L54.6824 71.624H53.3647L53.4588 71.7181ZM62.2118 65.5063L65.6 70.4946V66.824C65.6 66.4475 65.6 66.1652 65.5059 66.0711C65.5059 65.9769 65.2235 65.8828 64.9412 65.8828H64.5647V65.5063H67.2V65.8828H66.9176C66.6353 65.8828 66.3529 65.8828 66.3529 66.0711C66.3529 66.1652 66.2588 66.3534 66.2588 66.6358V74.1652H65.7882L60.7059 66.6358V72.8475C60.7059 73.224 60.7059 73.4122 60.8 73.5063C60.8 73.6005 61.0824 73.6946 61.3647 73.6946H61.8353V74.0711H59.1059V73.6946H59.4824C59.8588 73.6946 60.0471 73.6946 60.1412 73.5063C60.1412 73.4122 60.2353 73.1299 60.2353 72.5652V66.6358C60.2353 66.3534 60.2353 66.0711 60.2353 66.0711C60.2353 66.0711 59.9529 65.9769 59.6706 65.9769H59.2V65.6005H62.4L62.2118 65.5063ZM73.8824 65.6946V68.0475H73.5059C73.1294 66.5416 72.3765 65.8828 71.4353 65.8828C70.4941 65.8828 70.6824 66.0711 70.4 66.4475C70.2118 66.824 70.1176 67.6711 70.1176 68.8946C70.1176 71.1534 70.1176 72.5652 70.3059 73.0358C70.4941 73.5063 70.7765 73.6946 71.3412 73.6946C72.3765 73.6946 73.1294 72.9416 73.6941 71.4358H74.0706V74.0711H73.5059C73.4118 73.8828 73.2235 73.6946 73.0353 73.5063C72.4706 73.9769 71.8118 74.1652 71.1529 74.1652C70.4941 74.1652 69.4588 73.7887 68.8 73.0358C68.1412 72.2828 67.7647 71.2475 67.7647 69.8358C67.7647 68.424 68.1412 67.3887 68.8 66.6358C69.4588 65.7887 70.4 65.4122 71.4353 65.4122C72.4706 65.4122 72.5647 65.6005 73.1294 66.0711C73.3176 65.9769 73.5059 65.7887 73.6 65.6946H73.9765H73.8824ZM77.8353 65.9769V73.6946H78.9647V74.0711H74.5412V73.6946H75.6706V65.9769H74.5412V65.6005H78.9647V65.9769H77.8353ZM53.4588 67.2005V68.3299L52.3294 71.1534H53.4588V71.624H52.1412L51.7647 72.4711C51.6706 72.8475 51.5765 73.0358 51.5765 73.224C51.5765 73.4122 51.7647 73.6005 52.2353 73.6005H52.7059V73.9769H49.9765V73.6005H50.1647C50.4471 73.6005 50.7294 73.6005 50.8235 73.4122C50.9176 73.3181 51.1059 73.0358 51.2 72.6593L53.4588 67.1064V67.2005ZM0 65.5063H7.05882V68.3299H6.68235C6.4 66.7299 5.74118 65.9769 4.70588 65.9769H4.51765V73.6946H5.83529V74.0711H1.22353V73.6946H2.54118V65.9769H2.35294C1.31765 65.9769 0.658824 66.7299 0.376471 68.3299H0L0 65.5063ZM49.9765 65.5063V65.8828H49.6941C49.4118 65.8828 49.1294 65.8828 49.1294 66.0711C49.1294 66.1652 49.0353 66.3534 49.0353 66.6358V74.1652H48.5647L43.4824 66.6358V72.8475C43.4824 73.224 43.4824 73.4122 43.5765 73.5063C43.5765 73.6005 43.8588 73.6946 44.1412 73.6946H44.6118V74.0711H41.8824V73.6946H42.2588C42.6353 73.6946 42.8235 73.6946 42.9176 73.5063C42.9176 73.4122 43.0118 73.1299 43.0118 72.5652V66.6358C43.0118 66.3534 43.0118 66.0711 43.0118 66.0711C43.0118 66.0711 42.7294 65.9769 42.4471 65.9769H41.9765V65.6005H45.1765L48.5647 70.5887V66.9181C48.5647 66.5416 48.5647 66.2593 48.4706 66.1652C48.4706 66.0711 48.1882 65.9769 47.9059 65.9769H47.5294V65.6005H50.0706L49.9765 65.5063ZM13.8353 69.9299H11.0118V73.6946H12.1412V74.0711H7.90588V73.6946H9.03529V65.9769H7.90588V65.6005H12.1412V65.9769H11.0118V69.4593H13.8353V65.9769H12.8V65.6005H17.0353V65.9769H15.9059V73.6946H17.0353V74.0711H12.8V73.6946H13.8353V69.9299ZM20.9882 65.9769V69.5534H21.2706C22.1176 69.5534 22.6824 69.0828 22.7765 68.0475H23.1529V71.5299H22.7765C22.7765 70.4946 22.2118 69.9299 21.2706 69.9299H20.9882V73.6005H22.4941C23.8118 73.6005 24.6588 72.8475 25.0353 71.2475H25.5059L25.3176 74.0711H17.8824V73.6946H19.0118V65.9769H17.8824V65.6005H25.0353V67.9534C25.1294 67.9534 24.7529 67.9534 24.7529 67.9534C24.4706 67.1063 24.1882 66.6358 23.7176 66.3534C23.3412 66.0711 22.7765 65.9769 22.1176 65.9769H20.9882ZM32.5647 65.9769V69.5534H32.7529C33.7882 69.5534 34.2588 69.0828 34.3529 68.0475H34.8235V71.624H34.4471C34.4471 71.1534 34.2588 70.7769 34.0706 70.4946C33.7882 70.2122 33.4118 70.024 32.7529 70.024H32.5647V73.6946H33.7882V74.0711H29.3647V73.6946H30.4941V65.9769H29.3647V65.6005H36.5176V68.2358H36.1412C35.8588 66.7299 35.1059 66.0711 33.8824 66.0711H32.5647V65.9769ZM40.2824 65.9769V73.6946H41.4118V74.0711H36.9882V73.6946H38.1176V65.9769H36.9882V65.6005H41.4118V65.9769H40.2824Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1069_3508">
                    <rect width="213.647" height="80" fill="white" />
                  </clipPath>
                </defs>
              </svg>{" "}
            </a>
          </div>

          <div className="header-menu-wrapper">
            <nav className="menu">
              <ul id="h-menu-1" className="h-menu-1">
                <li
                  id="menu-item-430"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-430"
                >
                  <a href="https://tfig.ny2.stonesoupdev.com/">
                    <span>Home</span>
                  </a>
                </li>
                <li
                  id="menu-item-246"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-246"
                >
                  <a href="https://tfig.ny2.stonesoupdev.com/important-dates/">
                    <span>Important Dates</span>
                  </a>
                </li>
                <li
                  id="menu-item-345"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-345"
                >
                  <a href="/news">
                    <span>News</span>
                  </a>
                </li>
                <li
                  id="menu-item-247"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-247"
                >
                  <a href="https://tfig.ny2.stonesoupdev.com/contact-us/">
                    <span>Contact Us</span>
                  </a>
                </li>
                <li
                  id="menu-item-1436"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1436"
                >
                  <a href="/my-account/">
                    <span>My Account</span>
                  </a>
                </li>
              </ul>
            </nav>
            <div className="phone">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M19.9995 22.621L16.4785 15.826C16.4705 15.83 14.5045 16.796 14.4145 16.837C12.1745 17.923 7.61555 9.017 9.80555 7.843L11.8885 6.817L8.39555 0L6.28955 1.039C-0.912452 4.794 10.5225 27.021 17.8895 23.654C18.0105 23.599 19.9915 22.625 19.9995 22.621Z"
                  fill="white"
                />
              </svg>
              <a href="tel:+1-770-233-9014">(770) 233-9014</a>
            </div>

            <div className="menu-buttons-desktop">
              <p>MENU</p>
              <button className="hamburger hamburger-desktop">
                <svg
                  width="40"
                  height="41"
                  viewBox="0 0 40 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_1361_5563"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="40"
                    height="41"
                  >
                    <rect y="0.5" width="40" height="40" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1361_5563)">
                    <path
                      d="M6.66667 30.5C6.19444 30.5 5.79861 30.3403 5.47917 30.0208C5.15972 29.7014 5 29.3056 5 28.8333C5 28.3611 5.15972 27.9653 5.47917 27.6458C5.79861 27.3264 6.19444 27.1667 6.66667 27.1667H33.3333C33.8056 27.1667 34.2014 27.3264 34.5208 27.6458C34.8403 27.9653 35 28.3611 35 28.8333C35 29.3056 34.8403 29.7014 34.5208 30.0208C34.2014 30.3403 33.8056 30.5 33.3333 30.5H6.66667ZM6.66667 22.1667C6.19444 22.1667 5.79861 22.0069 5.47917 21.6875C5.15972 21.3681 5 20.9722 5 20.5C5 20.0278 5.15972 19.6319 5.47917 19.3125C5.79861 18.9931 6.19444 18.8333 6.66667 18.8333H33.3333C33.8056 18.8333 34.2014 18.9931 34.5208 19.3125C34.8403 19.6319 35 20.0278 35 20.5C35 20.9722 34.8403 21.3681 34.5208 21.6875C34.2014 22.0069 33.8056 22.1667 33.3333 22.1667H6.66667ZM6.66667 13.8333C6.19444 13.8333 5.79861 13.6736 5.47917 13.3542C5.15972 13.0347 5 12.6389 5 12.1667C5 11.6944 5.15972 11.2986 5.47917 10.9792C5.79861 10.6597 6.19444 10.5 6.66667 10.5H33.3333C33.8056 10.5 34.2014 10.6597 34.5208 10.9792C34.8403 11.2986 35 11.6944 35 12.1667C35 12.6389 34.8403 13.0347 34.5208 13.3542C34.2014 13.6736 33.8056 13.8333 33.3333 13.8333H6.66667Z"
                      fill="white"
                    />
                  </g>
                </svg>
              </button>
            </div>
          </div>

          <div className="mobile-buttons">
            <div className="search-div-mobile">
              <button className="search-close-mobile">&#10005;</button>
              <form
                action="https://tfig.ny2.stonesoupdev.com"
                method="GET"
                className="header-search"
              >
                <label htmlFor="s-m" className="screen-reader-text">
                  Search
                </label>
                <input
                  type="text"
                  name="s"
                  id="s-m"
                  placeholder="Search"
                  autoComplete="off"
                  value=""
                />
                <button type="submit" className="search-submit-mobile">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="search">
                      <mask
                        id="mask0_1355_1140"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="30"
                        height="30"
                      >
                        <rect
                          id="Bounding box"
                          width="30"
                          height="30"
                          fill="#D9D9D9"
                        />
                      </mask>
                      <g mask="url(#mask0_1355_1140)">
                        <path
                          id="search_2"
                          d="M13.125 21.25C10.8542 21.25 8.93229 20.4635 7.35938 18.8906C5.78646 17.3177 5 15.3958 5 13.125C5 10.8542 5.78646 8.93229 7.35938 7.35938C8.93229 5.78646 10.8542 5 13.125 5C15.3958 5 17.3177 5.78646 18.8906 7.35938C20.4635 8.93229 21.25 10.8542 21.25 13.125C21.25 14.0417 21.1042 14.9062 20.8125 15.7188C20.5208 16.5312 20.125 17.25 19.625 17.875L24.625 22.875C24.8542 23.1042 24.9688 23.3958 24.9688 23.75C24.9688 24.1042 24.8542 24.3958 24.625 24.625C24.3958 24.8542 24.1042 24.9688 23.75 24.9688C23.3958 24.9688 23.1042 24.8542 22.875 24.625L17.875 19.625C17.25 20.125 16.5312 20.5208 15.7188 20.8125C14.9062 21.1042 14.0417 21.25 13.125 21.25ZM13.125 18.75C14.6875 18.75 16.0156 18.2031 17.1094 17.1094C18.2031 16.0156 18.75 14.6875 18.75 13.125C18.75 11.5625 18.2031 10.2344 17.1094 9.14062C16.0156 8.04688 14.6875 7.5 13.125 7.5C11.5625 7.5 10.2344 8.04688 9.14062 9.14062C8.04688 10.2344 7.5 11.5625 7.5 13.125C7.5 14.6875 8.04688 16.0156 9.14062 17.1094C10.2344 18.2031 11.5625 18.75 13.125 18.75Z"
                          fill="#086CE1"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
              </form>
            </div>
            <button className="search-mobile">
              <svg
                width="40"
                height="41"
                viewBox="0 0 40 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="search">
                  <mask
                    id="mask0_1361_5554"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="40"
                    height="41"
                  >
                    <rect
                      id="Bounding box"
                      y="0.5"
                      width="40"
                      height="40"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_1361_5554)">
                    <path
                      id="search_2"
                      d="M17.3584 27.7167C14.7428 27.7167 12.5292 26.8109 10.7175 24.9992C8.90584 23.1875 8 20.9739 8 18.3584C8 15.7428 8.90584 13.5292 10.7175 11.7175C12.5292 9.90584 14.7428 9 17.3584 9C19.9739 9 22.1875 9.90584 23.9992 11.7175C25.8109 13.5292 26.7167 15.7428 26.7167 18.3584C26.7167 19.4142 26.5488 20.41 26.2128 21.3459C25.8769 22.2817 25.421 23.1095 24.8451 23.8294L30.6041 29.5884C30.868 29.8524 31 30.1883 31 30.5962C31 31.0042 30.868 31.3401 30.6041 31.6041C30.3401 31.868 30.0042 32 29.5962 32C29.1883 32 28.8524 31.868 28.5884 31.6041L22.8294 25.8451C22.1095 26.421 21.2817 26.8769 20.3459 27.2128C19.41 27.5488 18.4142 27.7167 17.3584 27.7167ZM17.3584 24.8372C19.1581 24.8372 20.6878 24.2074 21.9476 22.9476C23.2074 21.6878 23.8372 20.1581 23.8372 18.3584C23.8372 16.5587 23.2074 15.029 21.9476 13.7692C20.6878 12.5094 19.1581 11.8795 17.3584 11.8795C15.5587 11.8795 14.029 12.5094 12.7692 13.7692C11.5094 15.029 10.8795 16.5587 10.8795 18.3584C10.8795 20.1581 11.5094 21.6878 12.7692 22.9476C14.029 24.2074 15.5587 24.8372 17.3584 24.8372Z"
                      fill="white"
                    />
                  </g>
                </g>
              </svg>
            </button>

            <button className="hamburger hamburger-mobile">
              <svg
                width="40"
                height="41"
                viewBox="0 0 40 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_1361_5563"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="40"
                  height="41"
                >
                  <rect y="0.5" width="40" height="40" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1361_5563)">
                  <path
                    d="M6.66667 30.5C6.19444 30.5 5.79861 30.3403 5.47917 30.0208C5.15972 29.7014 5 29.3056 5 28.8333C5 28.3611 5.15972 27.9653 5.47917 27.6458C5.79861 27.3264 6.19444 27.1667 6.66667 27.1667H33.3333C33.8056 27.1667 34.2014 27.3264 34.5208 27.6458C34.8403 27.9653 35 28.3611 35 28.8333C35 29.3056 34.8403 29.7014 34.5208 30.0208C34.2014 30.3403 33.8056 30.5 33.3333 30.5H6.66667ZM6.66667 22.1667C6.19444 22.1667 5.79861 22.0069 5.47917 21.6875C5.15972 21.3681 5 20.9722 5 20.5C5 20.0278 5.15972 19.6319 5.47917 19.3125C5.79861 18.9931 6.19444 18.8333 6.66667 18.8333H33.3333C33.8056 18.8333 34.2014 18.9931 34.5208 19.3125C34.8403 19.6319 35 20.0278 35 20.5C35 20.9722 34.8403 21.3681 34.5208 21.6875C34.2014 22.0069 33.8056 22.1667 33.3333 22.1667H6.66667ZM6.66667 13.8333C6.19444 13.8333 5.79861 13.6736 5.47917 13.3542C5.15972 13.0347 5 12.6389 5 12.1667C5 11.6944 5.15972 11.2986 5.47917 10.9792C5.79861 10.6597 6.19444 10.5 6.66667 10.5H33.3333C33.8056 10.5 34.2014 10.6597 34.5208 10.9792C34.8403 11.2986 35 11.6944 35 12.1667C35 12.6389 34.8403 13.0347 34.5208 13.3542C34.2014 13.6736 33.8056 13.8333 33.3333 13.8333H6.66667Z"
                    fill="white"
                  />
                </g>
              </svg>
            </button>
          </div>
        </div>
        <div className="row middle">
          <div className="menus-wrapper">
            <nav className="header-menu mobile">
              <ul id="h-menu-3" className="h-menu-3">
                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-430">
                  <a href="https://tfig.ny2.stonesoupdev.com/">
                    <span>Home</span>
                  </a>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-246">
                  <a href="https://tfig.ny2.stonesoupdev.com/important-dates/">
                    <span>Important Dates</span>
                  </a>
                </li>
                <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-345">
                  <a href="/news">
                    <span>News</span>
                  </a>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-247">
                  <a href="https://tfig.ny2.stonesoupdev.com/contact-us/">
                    <span>Contact Us</span>
                  </a>
                </li>
                <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1436">
                  <a href="/my-account/">
                    <span>My Account</span>
                  </a>
                </li>
              </ul>
            </nav>
            <nav className="header-menu">
              <ul id="h-menu-2" className="h-menu-2">
                <li
                  id="menu-item-216"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-216"
                >
                  <a href="#">
                    <span>Accounting</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-347"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-347"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/accounting/accounting-bookkeeping/">
                        <span>Bookkeeping and Payroll</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-348"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-348"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/accounting/accounting-taxes/">
                        <span>Taxes</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-217"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-217"
                >
                  <a href="#">
                    <span>Authorities and DOT Numbers</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-349"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-349"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/authorities-and-dot-numbers/authorities-operating/">
                        <span>Operating Authorities</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-350"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-350"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/authorities-and-dot-numbers/authorities-authority-amendments/">
                        <span>Operating Authority Amendments</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-352"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-352"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/authorities-and-dot-numbers/authorities-dot-number/">
                        <span>DOT Number</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-353"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-353"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/authorities-and-dot-numbers/dot-files/">
                        <span>DOT Files</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-354"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-354"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/audits-dot-and-irp-ifta/safety-audits/">
                        <span>DOT/FMCSA Audits</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-218"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-218"
                >
                  <a href="#">
                    <span>Intrastate Compliance</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-1101"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1101"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/intrastate-compliance/intrastate-authority-filings-by-state/">
                        <span>Intrastate Authority Filings by State</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-355"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-355"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/california/california-intrastate-requirements/">
                        <span>California Intrastate Requirements</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-356"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-356"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/intrastate-compliance/puco/">
                        <span>PUCO</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-357"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-357"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/intrastate-compliance/new-jersey/">
                        <span>New Jersey</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-219"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-219"
                >
                  <a href="#">
                    <span>Corporations and LLCs</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-358"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-358"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/corporations-and-llcs-parent/corporations-and-llcs/">
                        <span>Corporations and LLCs</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-359"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-359"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/corporations-and-llcs-parent/corporations-and-llc-amendments/">
                        <span>Corporation and LLC Amendments</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-220"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-220"
                >
                  <a href="#">
                    <span>Drug and Alcohol</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-360"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-360"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/drug-and-alcohol/enrollment/">
                        <span>Drug and Alcohol Enrollment</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-361"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-361"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/drug-and-alcohol/drug-and-alcohol-testing/">
                        <span>Drug and Alcohol Testing</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-221"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-221"
                >
                  <a href="#">
                    <span>Fuel Taxes</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-363"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-363"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/fuel-taxes/ifta-decal/">
                        <span>International Fuel Tax Decal Order (IFTA)</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-362"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-362"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/fuel-taxes/international-fuel-tax-ifta-filing/">
                        <span>International Fuel Tax (IFTA) Filing</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-364"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-364"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/fuel-taxes/ifta-audits/">
                        <span>IFTA Audits</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-222"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-222"
                >
                  <a href="#">
                    <span>Registration</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-365"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-365"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/registration/irp-tags/">
                        <span>IRP Tags</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-366"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-366"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/registration/heavy-highway-use-tax-2290/">
                        <span>Heavy Highway Use Tax (2290)</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-367"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-367"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/registration/irp-audits/">
                        <span>IRP Audits</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-223"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-223"
                >
                  <a href="#">
                    <span>Permits</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-368"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-368"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/permits/trip-fuel/">
                        <span>Trip and Fuel Permits</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-369"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-369"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/permits/ifta-decal-weight-distance-permits/">
                        <span>IFTA and Weight Distance Permits</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-370"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-370"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/permits/osow/">
                        <span>Oversize/Overweight Permits</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-371"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-371"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/permits/annual-blanket-permit/">
                        <span>Annual/Blanket Permits</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-224"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-224"
                >
                  <a href="#">
                    <span>Titles</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-372"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-372"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/titles/title-transfer/">
                        <span>Title Transfer</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-373"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-373"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/titles/title-amendment/">
                        <span>Title Amendment</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-374"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-374"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/titles/title-replacement/">
                        <span>Replacement Title</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-375"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-375"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/titles/registration-only-title/">
                        <span>Registration Only Title</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-346"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-346"
                >
                  <a href="https://tfig.ny2.stonesoupdev.com/weigh-station-bypass-and-tolls-payments/">
                    <span>Weigh Station Bypass and Tolls Payments</span>
                  </a>
                </li>
                <li
                  id="menu-item-226"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-226"
                >
                  <a href="#">
                    <span>Audits &ndash; DOT and IRP/IFTA</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-376"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-376"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/audits-dot-and-irp-ifta/safety-audits/">
                        <span>DOT/FMCSA Audits</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-377"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-377"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/audits-dot-and-irp-ifta/irp-ifta-audits/">
                        <span>IRP/IFTA Audits</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-227"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-227"
                >
                  <a href="#">
                    <span>California</span>
                  </a>
                  <ul className="sub-menu">
                    <li
                      id="menu-item-378"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-378"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/california/carbs/">
                        <span>California Air Resource Board (CARBs)</span>
                      </a>
                    </li>
                    <li
                      id="menu-item-379"
                      className="menu-item menu-item-type-post_type menu-item-object-page menu-item-379"
                    >
                      <a href="https://tfig.ny2.stonesoupdev.com/california/california-intrastate-requirements/">
                        <span>California Intrastate Requirements</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>

          <div className="social-search">
            <div className="search-div">
              <button className="search-close">&#10005;</button>
              <form
                action="https://tfig.ny2.stonesoupdev.com"
                method="GET"
                className="header-search"
              >
                <label htmlFor="s" className="screen-reader-text">
                  Search
                </label>
                <input
                  type="text"
                  name="s"
                  id="s"
                  placeholder="Search"
                  autoComplete="off"
                  value=""
                />
                <button type="submit" className="search-submit">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="search">
                      <mask
                        id="mask0_1355_1140"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="30"
                        height="30"
                      >
                        <rect
                          id="Bounding box"
                          width="30"
                          height="30"
                          fill="#D9D9D9"
                        />
                      </mask>
                      <g mask="url(#mask0_1355_1140)">
                        <path
                          id="search_2"
                          d="M13.125 21.25C10.8542 21.25 8.93229 20.4635 7.35938 18.8906C5.78646 17.3177 5 15.3958 5 13.125C5 10.8542 5.78646 8.93229 7.35938 7.35938C8.93229 5.78646 10.8542 5 13.125 5C15.3958 5 17.3177 5.78646 18.8906 7.35938C20.4635 8.93229 21.25 10.8542 21.25 13.125C21.25 14.0417 21.1042 14.9062 20.8125 15.7188C20.5208 16.5312 20.125 17.25 19.625 17.875L24.625 22.875C24.8542 23.1042 24.9688 23.3958 24.9688 23.75C24.9688 24.1042 24.8542 24.3958 24.625 24.625C24.3958 24.8542 24.1042 24.9688 23.75 24.9688C23.3958 24.9688 23.1042 24.8542 22.875 24.625L17.875 19.625C17.25 20.125 16.5312 20.5208 15.7188 20.8125C14.9062 21.1042 14.0417 21.25 13.125 21.25ZM13.125 18.75C14.6875 18.75 16.0156 18.2031 17.1094 17.1094C18.2031 16.0156 18.75 14.6875 18.75 13.125C18.75 11.5625 18.2031 10.2344 17.1094 9.14062C16.0156 8.04688 14.6875 7.5 13.125 7.5C11.5625 7.5 10.2344 8.04688 9.14062 9.14062C8.04688 10.2344 7.5 11.5625 7.5 13.125C7.5 14.6875 8.04688 16.0156 9.14062 17.1094C10.2344 18.2031 11.5625 18.75 13.125 18.75Z"
                          fill="#086CE1"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
              </form>
            </div>
            <button className="search-open">
              <svg
                width="40"
                height="41"
                viewBox="0 0 40 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="search">
                  <mask
                    id="mask0_1361_5554"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="40"
                    height="41"
                  >
                    <rect
                      id="Bounding box"
                      y="0.5"
                      width="40"
                      height="40"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_1361_5554)">
                    <path
                      id="search_2"
                      d="M17.3584 27.7167C14.7428 27.7167 12.5292 26.8109 10.7175 24.9992C8.90584 23.1875 8 20.9739 8 18.3584C8 15.7428 8.90584 13.5292 10.7175 11.7175C12.5292 9.90584 14.7428 9 17.3584 9C19.9739 9 22.1875 9.90584 23.9992 11.7175C25.8109 13.5292 26.7167 15.7428 26.7167 18.3584C26.7167 19.4142 26.5488 20.41 26.2128 21.3459C25.8769 22.2817 25.421 23.1095 24.8451 23.8294L30.6041 29.5884C30.868 29.8524 31 30.1883 31 30.5962C31 31.0042 30.868 31.3401 30.6041 31.6041C30.3401 31.868 30.0042 32 29.5962 32C29.1883 32 28.8524 31.868 28.5884 31.6041L22.8294 25.8451C22.1095 26.421 21.2817 26.8769 20.3459 27.2128C19.41 27.5488 18.4142 27.7167 17.3584 27.7167ZM17.3584 24.8372C19.1581 24.8372 20.6878 24.2074 21.9476 22.9476C23.2074 21.6878 23.8372 20.1581 23.8372 18.3584C23.8372 16.5587 23.2074 15.029 21.9476 13.7692C20.6878 12.5094 19.1581 11.8795 17.3584 11.8795C15.5587 11.8795 14.029 12.5094 12.7692 13.7692C11.5094 15.029 10.8795 16.5587 10.8795 18.3584C10.8795 20.1581 11.5094 21.6878 12.7692 22.9476C14.029 24.2074 15.5587 24.8372 17.3584 24.8372Z"
                      fill="white"
                    />
                  </g>
                </g>
              </svg>
            </button>
            <a
              href="https://www.facebook.com/TFIGofGA/?eid=ARAYdtYacizC_TI8OxVplaG06Gi4dOBuYpmYP8Jri3XpXdoqQ1kGlEqEmJKajHY6YQrZ0ud2TokqBLn0"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  d="M0 0.511963V24.4878H24V0.511963H0ZM16 7.50492H14.077C13.461 7.50492 13 7.75667 13 8.39303V9.50291H16L15.761 12.4999H13V20.4918H10V12.4999H8V9.50291H10V7.58185C10 5.56188 11.064 4.50794 13.461 4.50794H16V7.50492Z"
                  fill="white"
                />
              </svg>
            </a>
            <a href="https://x.com/TFIGofGA" target="_blank">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="x"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M24 0H0V24H24V0ZM19.4785 4L13.5222 10.7749H13.5218L20 20H15.2356L10.8732 13.7878L5.41155 20H4L10.2466 12.8955L4 4H8.76437L12.8952 9.88256L18.0671 4H19.4785ZM10.956 12.0881L11.5889 12.9738V12.9742L15.8997 19.0075H18.0677L12.7851 11.6137L12.1522 10.728L8.0882 5.03974H5.92015L10.956 12.0881Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </div>
        <div className="row last"></div>
      </div>
    </header>
  );
};

export default Header;
